import React from 'react';
import AppRoutes from './routes/AppRoutes';

import './App.css';
import './Index.css';

const App = () => {
  return (
    <AppRoutes />
  )
};

export default App;
